var map = {
	"./aara.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/aara.ogg",
	"./achar.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/achar.ogg",
	"./baas.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/baas.ogg",
	"./badar.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/badar.ogg",
	"./baja.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/baja.ogg",
	"./bakhra.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/bakhra.ogg",
	"./banaye.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/banaye.ogg",
	"./bato.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/bato.ogg",
	"./bhat.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/bhat.ogg",
	"./biralo.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/biralo.ogg",
	"./bunu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/bunu.ogg",
	"./chalaye.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/chalaye.ogg",
	"./chhala.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/chhala.ogg",
	"./chhana.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/chhana.ogg",
	"./cycle.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/cycle.ogg",
	"./daat.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/daat.ogg",
	"./dhaan.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/dhaan.ogg",
	"./dhara.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/dhara.ogg",
	"./dhoka.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/dhoka.ogg",
	"./duita.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/duita.ogg",
	"./euta.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/euta.ogg",
	"./fal.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/fal.ogg",
	"./fed.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/fed.ogg",
	"./ful.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/ful.ogg",
	"./gai.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/gai.ogg",
	"./gaida.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/gaida.ogg",
	"./gaun.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/gaun.ogg",
	"./ghoda.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/ghoda.ogg",
	"./ghum.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/ghum.ogg",
	"./goda.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/goda.ogg",
	"./haat.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/haat.ogg",
	"./haga.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/haga.ogg",
	"./hatti.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/hatti.ogg",
	"./headphone.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/headphone.ogg",
	"./hiu.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/hiu.ogg",
	"./jhola.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/jhola.ogg",
	"./kaan.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/kaan.ogg",
	"./kachuwa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/kachuwa.ogg",
	"./kagaj.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/kagaj.ogg",
	"./kamila.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/kamila.ogg",
	"./kapal.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/kapal.ogg",
	"./khanekura.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/khanekura.ogg",
	"./khasi.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/khasi.ogg",
	"./khat.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/khat.ogg",
	"./kitab.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/kitab.ogg",
	"./kukhura.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/kukhura.ogg",
	"./kukur.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/kukur.ogg",
	"./machha.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/machha.ogg",
	"./manis.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/manis.ogg",
	"./mukh.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/mukh.ogg",
	"./paat.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/paat.ogg",
	"./pado.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/pado.ogg",
	"./pahad.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/pahad.ogg",
	"./paisa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/paisa.ogg",
	"./pani.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/pani.ogg",
	"./panihaas.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/panihaas.ogg",
	"./parewa.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/parewa.ogg",
	"./pathhi.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/pathhi.ogg",
	"./pathi.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/pathi.ogg",
	"./ping.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/ping.ogg",
	"./pokhari.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/pokhari.ogg",
	"./raja.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/raja.ogg",
	"./rang.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/rang.ogg",
	"./ribbon.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/ribbon.ogg",
	"./rukh.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/rukh.ogg",
	"./sarir.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/sarir.ogg",
	"./sathi.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/sathi.ogg",
	"./soon.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/soon.ogg",
	"./surya.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/surya.ogg",
	"./taati.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/taati.ogg",
	"./table.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/table.ogg",
	"./tauko.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/tauko.ogg",
	"./tika.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/tika.ogg",
	"./topi.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/topi.ogg",
	"./upiya.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/upiya.ogg",
	"./vada.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/vada.ogg",
	"./vangera.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/vangera.ogg",
	"./veda.ogg": "./src/EGRContent/Play/DragandDropPlay/audios/words/veda.ogg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Play/DragandDropPlay/audios/words sync recursive ^\\.\\/.*$";